<script setup>
import deadlineChart from "@/components/Charts/deadlineChart.js";
import LineChart from "@/components/Charts/LineChart.vue";
import { formatDate } from "@/utils/formatDate";
// import * as XLSX from "xlsx";
import { Workbook } from "@syncfusion/ej2-excel-export";
// import { ExcelExport } from '@syncfusion/ej2-excel-export';
// import ExcelJS from 'exceljs';
const { chartOptions } = deadlineChart;
import { ref, onMounted, computed } from "vue";

// const exportChartDataToExcel_ExcelExport = () => {
// // Prepare the data
// const rows = [];
//   const chartDataLabels = chartData.datasets.labels;

//   // Add header row (chart labels)
//   rows.push(['Date', 'Plan', 'Fact', 'Deviation']);

//   // Add data rows for each item in the chart data
//   data.Chart.forEach(item => {
//     const date = new Date(item.Date.seconds * 1000).toLocaleDateString('en-GB');
//     rows.push([date, item.Plan, item.Fact, item.Deviation]);
//   });

//   // Initialize ExcelExport instance
//   const excelExport = new ExcelExport();

//   // Define the Excel export settings (including worksheet and data)
//   const workbook = excelExport.createWorkbook({
//     sheets: [{
//       name: 'Отчет',
//       rows: rows.map((row, index) => {
//         return {
//           index: index,
//           cells: row.map((cell, colIndex) => ({
//             index: colIndex,
//             value: cell
//           }))
//         };
//       })
//     }]
//   });

//   // Add a chart to the worksheet
//   workbook.sheets[0].charts.add({
//     type: 'ColumnClustered', // Chart type
//     range: 'A1:D' + rows.length, // Data range for the chart
//     position: { x: 5, y: 1 },  // Top-left position for the chart
//     size: { width: 400, height: 300 }  // Size of the chart
//   });

//   // Create a filename based on the current date
//   const date = new Date();
//   const dateString = date.toLocaleDateString('en-GB').replace(/\//g, '_');
//   const fileName = `${dateString}_мултикейс_СРЕДНИЙ ПОКАЗАТЕЛЬ ПО ВЫПОЛНЕНИЮ ГПР.xlsx`;

//   // Export the workbook with the chart
//   excelExport.save(workbook, fileName);
// };

const exportChartDataToExcel = () => {
  // Prepare the data
  const rows = [];
  // const chartDataLabels = chartData.datasets.labels;

  // Add header row (chart labels)
  rows.push(["Date", "Plan", "Fact", "Deviation"]);

  // Add data rows for each item in the chart data
  data.value.Chart.forEach((item) => {
    const date = new Date(item.Date.seconds * 1000).toLocaleDateString("en-GB");
    rows.push([date, item.Plan, item.Fact, item.Deviation]);
  });

  // Create the Workbook instance
  const workbook = new Workbook();
  const sheet = workbook.addSheet("Отчет");

  // Add the data to the sheet
  sheet.range("A1").values = rows;

  // Create a chart using the data (e.g., a column chart)
  sheet.charts.add({
    chartType: "ColumnClustered",
    range: "A1:D" + rows.length, // Data range for the chart
    topLeft: "F1", // Position for the chart (top-left corner)
    bottomRight: "K15", // Position for the chart (bottom-right corner)
  });

  // Save the workbook as an Excel file
  const date = new Date();
  const dateString = date.toLocaleDateString("en-GB").replace(/\//g, "_");
  const fileName = `${dateString}_мултикейс_СРЕДНИЙ ПОКАЗАТЕЛЬ ПО ВЫПОЛНЕНИЮ ГПР.xlsx`;

  // Export the workbook with the chart
  workbook.save(fileName);
};

// const exportChartDataToExcel_xlsx = () => {
//   const rows = [];
//   const chartDataLabels = chartData.datasets.labels;
//   rows.push(["Date", "Plan", "Fact", "Deviation"]);

//   data.Chart.forEach((item) => {
//     const date = new Date(item.Date.seconds * 1000).toLocaleDateString("en-GB");
//     rows.push([date, item.Plan, item.Fact, item.Deviation]);
//   });

//   const worksheet = XLSX.utils.aoa_to_sheet(rows);

//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Отчет");

//   const date = new Date();
//   const dateString = date.toLocaleDateString("en-GB").replace(/\//g, "_");
//   const fileName = `${dateString}_мултикейс_СРЕДНИЙ ПОКАЗАТЕЛЬ ПО ВЫПОЛНЕНИЮ ГПР.xlsx`;
//   XLSX.writeFile(workbook, fileName);
// };

// const exportChartDataToExcel_excelJS = async () => {
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Chart Data");
//   worksheet.addRow(["Date", "Plan", "Fact", "Deviation"]);

//   data.Chart.forEach((item) => {
//     const date = new Date(item.Date.seconds * 1000).toLocaleDateString("en-GB");
//     worksheet.addRow([date, item.Plan, item.Fact, item.Deviation]);
//   });

//   const chart = worksheet.addChart({
//     type: "line",
//     name: "Chart Data",
//     data: {
//       labels: chartData.datasets.labels,
//       datasets: [
//         { name: "Plan", values: data.Chart.map((item) => item.Plan) },
//         { name: "Fact", values: data.Chart.map((item) => item.Fact) },
//         { name: "Deviation", values: data.Chart.map((item) => item.Deviation) },
//       ],
//     },
//     options: {
//       responsive: true,
//       title: "Отчетa",
//     },
//   });
//   const buffer = await workbook.xlsx.writeBuffer();
//   const date = new Date();
//   const fileName = `${date.toLocaleDateString("en-GB").replace(/\//g, "_")}_мултикейс_СРЕДНИЙ ПОКАЗАТЕЛЬ ПО ВЫПОЛНЕНИЮ ГПР.xlsx`;

//   const blob = new Blob([buffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   saveAs(blob, fileName);
// };

const props = defineProps({
  construction: {
    type: Object,
    required: true,
  },
});

const data = ref({});
const isLoading = ref(true);

const labels = computed(() =>
  data.value.chartList
    ? data.value.chartList.map((e) => formatDate(e.date.seconds))
    : [],
);
const plan = computed(() =>
  data.value.chartList ? data.value.chartList.map((e) => e.plan) : [],
);
const fact = computed(() =>
  data.value.chartList ? data.value.chartList.map((e) => e.fact) : [],
);
const deviation = computed(() =>
  data.value.chartList ? data.value.chartList.map((e) => e.deviation) : [],
);

const chartData = computed(() => ({
  labels: [...new Set(labels.value)],
  datasets: [
    {
      label: "Plan",
      data: plan.value,
      borderColor: "#4285F4",
      backgroundColor: "#4285F4",
      pointBorderColor: "#4285F4",
      pointBackgroundColor: "#4285F4",
      fill: false,
      tension: 0.1,
      borderWidth: 2,
    },
    {
      label: "Data",
      data: fact.value,
      borderColor: "#FFA726",
      backgroundColor: "#FFA726",
      pointBorderColor: "#FFA726",
      pointBackgroundColor: "#FFA726",
      fill: false,
      tension: 0.1,
      borderWidth: 2,
    },
    {
      label: "Deviation",
      data: deviation.value,
      borderColor: "#FF5252",
      backgroundColor: "#FF5252",
      pointBorderColor: "#FF5252",
      pointBackgroundColor: "#FF5252",
      fill: false,
      tension: 0.1,
      borderWidth: 2,
    },
  ],
}));
const {
  ValueRequest_String,
} = require("../../../proto-out/IMultiStatisticsService_pb");

const {
  MultiStatisticsServiceClient,
} = require("../../../proto-out/IMultiStatisticsService_grpc_web_pb");

const store = useStore();
import { useStore } from "vuex";

let authToken = computed(() => store.getters["users/tokenUser"]);
let serverUrl = computed(() => store.getters["appData/getServerUrl"]);

const fetchDataFromGrpc = async () => {
  try {
    const client = new MultiStatisticsServiceClient(serverUrl.value);
    const metadata = { Authorization: `Bearer ${authToken.value}` };
    const request = new ValueRequest_String();
    request.setValue(props.construction.actualinstance);

    const getGprDynamicsData = await new Promise((resolve, reject) => {
      client.getGprDynamics(request, metadata, (err, response) => {
        if (err) {
          console.error("gRPC Error:", err.message);
          reject(new Error("Failed to fetch data from gRPC"));
        } else {
          resolve(response.toObject());
        }
      });
    });
    data.value = getGprDynamicsData;
  } catch (error) {
    console.error(error);
    // throw error;
  }
  isLoading.value = false;
};
onMounted(() => {
  fetchDataFromGrpc();
});
</script>

<template>
  <v-card-text align="center" class="title"
    >СРЕДНИЙ ПОКАЗАТЕЛЬ ПО ВЫПОЛНЕНИЮ ГПР</v-card-text
  >
  <LineChart
    height="50"
    :chartData="chartData"
    :chartOptions="chartOptions"
  />
  <v-container fluid class="legend-wrapper pt-10">
    <v-row align="center">
      <!-- Left Side Labels -->
      <v-col style="max-width: 19em" class="col-1 pa-0">
        <v-col class="pb-0">
          <v-icon size="10" color="blue">mdi-circle</v-icon>
          <span class="legend-text ml-1">План</span>
        </v-col>

        <v-col>
          <v-icon size="10" color="yellow">mdi-circle</v-icon>
          <span class="legend-text ml-1">Факт</span>
        </v-col>
      </v-col>

      <v-col style="max-width: 180px" class="col-1 pa-0">
        <v-col class="pb-0">
          <v-icon size="10" color="red">mdi-circle</v-icon>
          <span class="legend-text ml-1">Отклонение</span>
        </v-col>
        <v-col>
          <v-icon size="10" color="green">mdi-circle</v-icon>
          <span class="legend-text ml-1">Опережение</span>
        </v-col>
      </v-col>

      <!-- Red Cards Section -->
      <v-col class="col-9">
        <v-row dense>
          <v-card class="red-card pa-2">
            <span class="red-card-text"
              >{{ data?.percentagedeviation?.toFixed(2) }}%</span
            >
            <span class="legend-text ml-3">ОТКЛОНЕНИЕ В ПРОЦЕНТАХ</span>
          </v-card>
          <v-card class="red-card ml-4 pa-2">
            <span class="red-card-text">{{ data?.daysdeviation }} дн.</span>
            <span class="legend-text ml-3">ОТКЛОНЕНИЕ В ДНЯХ</span>
          </v-card>
        </v-row>
      </v-col>

      <!-- Export Button -->
      <v-col class="col-2">
        <v-btn
          @click="exportChartDataToExcel"
          rounded="lg"
          height="3vw"
          style="font-size: 0.8vw"
        >
          ЭКСПОРТ</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.title {
  font-size: 1.5vw;
  color: #00a3ff;
  font-weight: bold;
}
.legend-text {
  font-size: 0.8vw;
}
.red-card {
  background-color: red;
  min-width: 15vw;
}
.red-card-text {
  font-size: 1.4vw;
}
.col-1 {
  flex-basis: 13%;
  max-width: 13%;
}
.col-2 {
  flex-basis: 13%;
  max-width: 13%;
}
.col-9 {
  flex-basis: 60%;
  max-width: 60%;
}
</style>
